export const asiadata = [
  ["Country", "Members"],
  ["Afghanistan", 0],
  ["Armenia", 40],
  ["Azerbaijan", 29],
  ["Bahrain", 54],
  ["Bangladesh", 5],
  ["Bhutan", 0],
  ["Brunei", 4],
  ["Cambodia", 8],
  ["China", 451],
  ["Cyprus", 50],
  ["Georgia", 48],
  ["India", 1229],
  ["Indonesia", 207],
  ["Iran", 4],
  ["Iraq", 3],
  ["Israel", 123],
  ["Japan", 854],
  ["Jordan", 123],
  ["Kazakhstan", 111],
  ["Kuwait", 69],
  ["Kyrgyzstan", 18],
  ["Lebanon", 131],
  ["Malaysia", 242],
  ["Maldives", 20],
  ["Mongolia", 6],
  ["Myanmar", 1],
  ["Nepal", 1],
  ["North Korea", 0],
  ["Oman", 74],
  ["Pakistan", 18],
  ["Philippines", 194],
  ["Qatar", 119],
  ["Saudi Arabia", 281],
  ["Singapore", 1067],
  ["Sri Lanka", 55],
  ["South Korea", 408],
  ["Syria", 0],
  ["Taiwan", 164],
  ["Tajikistan", 1],
  ["Thailand", 234],
  ["Timor-Leste", 0],
  ["United Arab Emirates", 572],
  ["Uzbekistan", 7],
  ["Vietnam", 80],
  ["Yemen", 0]
]


export const eurpoe = [
  ["Country", "Members"],
  ["Albania", 2],
  ["Andorra", 6],
  ["Armenia", 40],
  ["Austria", 145],
  ["Azerbaijan", 29],
  ["Belarus", 4],
  ["Belgium", 543],
  ["Bosnia and Herzegovina", 1],
  ["Bulgaria", 69],
  ["Croatia", 32],
  ["Cyprus", 50],
  ["Czech Republic", 184],
  ["Denmark", 152],
  ["Estonia", 114],
  ["Finland", 281],
  ["France", 1694],
  ["Georgia", 48],
  ["Germany", 1175],
  ["Greece", 135],
  ["Hungary", 256],
  ["Iceland", 79],
  ["Ireland", 485],
  ["Israel", 123],
  ["Italy", 1685],
  ["Latvia", 32],
  ["Lithuania", 99],
  ["Luxembourg", 98],
  ["Malta", 12],
  ["Moldova", 9],
  ["Monaco", 5],
  ["North Macedonia", 3],
  ["Montenegro", 5],
  ["Netherlands", 3],
  ["Norway", 96],
  ["Poland", 235],
  ["Portugal", 239],
  ["Romania", 280],
  ["Russia", 280],
  ["San Marino", 0],
  ["Serbia", 57],
  ["Slovakia", 121],
  ["Slovenia", 77],
  ["Spain", 769],
  ["Sweden", 575],
  ["Switzerland", 830],
  ["Ukraine", 425],
  ["United Kingdom", 4661],
  ["Vatican City", 0],
  ["Belize", 0]  
]

export const africadata = [
  ["Country", "Members"],
  ["Algeria", 2],
  ["Angola", 1],
  ["Antigua and Barbuda", 0], 
  ["Benin", 0],
  ["Botswana", 6],
  ["Burkina Faso", 3],
  ["Burundi", 1],
  ["Cabo Verde", 0],
  ["Cameroon", 2],
  ["Central African Republic", 0],
  ["Chad", 0],
  ["Comoros", 0],
  ["Congo (Congo-Brazzaville)", 1],
  ["Congo (Democratic Republic of the Congo)", 2],
  ["Djibouti", 0],
  ["Egypt", 126],
  ["Equatorial Guinea", 1],
  ["Eritrea", 0],
  ["Eswatini", 0],
  ["Ethiopia", 3],
  ["Gabon", 0],
  ["Gambia", 0],
  ["Ghana", 36],
  ["Guinea", 0],
  ["Guinea-Bissau", 1],
  ["Ivory Coast", 0], 
  ["Kenya", 173],
  ["Lesotho", 0],
  ["Liberia", 0],
  ["Libya", 0],
  ["Madagascar", 3],
  ["Malawi", 18],
  ["Mali", 4],
  ["Mauritania", 0],
  ["Mauritius", 9],
  ["Mozambique", 2],
  ["Morocco", 79],
  ["Namibia", 11],
  ["Niger", 0],
  ["Nigeria", 82],
  ["Rwanda", 10],
  ["CG", 2],
  ["Senegal", 27],
  ["Seychelles", 0],
  ["Sierra Leone", 0],
  ["Somalia", 0],
  ["Western Sahara", 0],
  ["Togo", 0],
  ["TN", 49],
  ["South Africa", 537],
  ["CD", 2],
  ["Swaziland", 0],
  ["SS", 0],
  ["Sudan", 1],
  ["Tanzania", 3],
  ["Uganda", 49],
  ["Zambia", 3],
  ["Zimbabwe", 8]
]
export const southamerica = [
  ["Country", "Members"],
  ["Argentina", 192],
  ["Bolivia", 9],
  ["Brazil", 369],
  ["Chile", 112],
  ["Colombia", 96],
  ["Ecuador", 36],
  ["Guyana", 3],
  ["Paraguay", 3],
  ["Peru", 153],
  ["Suriname", 1],
  ["Trinidad and Tobago", 26],
  ["Uruguay", 65],
  ["Venezuela", 32],
]


export const northamerica = [
  ["Country", "Members"],
  ["Antigua and Barbuda", 0],
  ["Bahamas", 2],
  ["Barbados", 5],
  ["Belize", 0],
  ["Canada", 5207],
  ["Costa Rica", 75],
  ["GreenLand", 1],
  ["Dominican Republic", 54],
  ["El Salvador", 7],
  ["Guatemala", 21],
  ["Haiti", 0],
  ["Honduras", 7],
  ["Jamaica", 8],
  ["Mexico", 209],
  ["Nicaragua", 3],
  ["Panama", 59],
  ["United States", 24789]
]

export const ocenia = [
  ["Country", "Members"],
  ["Australia", 1985],
  ["Fiji", 1],
  ["Kiribati", 0],
  ["Marshall Islands", 0],
  ["Micronesia", 0],
  ["Nauru", 0],
  ["New Zealand", 320],
  ["Palau", 0],
  ["Papua New Guinea", 0],
  ["Samoa", 0],
  ["Solomon Islands", 0],
  ["Tonga", 0],
  ["Tuvalu", 0],
  ["Vanuatu", 0]
]
